module.exports = __webpack_public_path__ + "resources/img/theme_facetec.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/theme_facetec.gif
// module id = 1370
// module chunks = 0